import { forwardRef } from 'react'

import styles from './CheckoutFooter.module.css'

import type { FooterLink } from '../../types'

export interface CheckoutFooterProps {
  /** Disclaimer title (e.g., "Disclaimer") */
  disclaimerTitle?: string
  /** Disclaimer text */
  disclaimer?: string
  /** Footer links (e.g., Terms, Privacy) */
  links?: FooterLink[]
  /** Copyright text */
  copyright?: string
  /** Additional class name */
  className?: string
}

/**
 * CheckoutFooter - Footer component for checkout page
 *
 * Displays disclaimer text, links, and copyright
 */
export const CheckoutFooter = forwardRef<HTMLDivElement, CheckoutFooterProps>(
  ({ disclaimerTitle, disclaimer, links = [], copyright, className }, ref) => {
    return (
      <div ref={ref} className={`${styles.footer} ${className ?? ''}`}>
        {disclaimerTitle && <h4 className={styles.disclaimerTitle}>{disclaimerTitle}</h4>}

        {disclaimer && <p className={styles.disclaimer}>{disclaimer}</p>}

        {links.length > 0 && (
          <div className={styles.links}>
            {links.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className={styles.link}
                target="_blank"
                rel="noopener noreferrer"
                data-ga-action-name={`link_${link.label.toLowerCase().replace(/\s+/g, '_')}_click`}
                data-ga-module="checkout_footer"
              >
                {link.label}
              </a>
            ))}
          </div>
        )}

        {copyright && <p className={styles.copyright}>{copyright}</p>}
      </div>
    )
  }
)

CheckoutFooter.displayName = 'CheckoutFooter'
